const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgId(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 62.35291 59.95472",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M39.79832,35.60477v-1.033a.52375.52375,0,0,0-.341-.489c-2.408-.907-5.081-2.033-5.306-2.734v-.736a4.61848,4.61848,0,0,0,1.127-2.005,1.17333,1.17333,0,0,0,.236-1.729v-1.648c0-1.7-.972-2.864-3.195-2.864-2.164,0-3.195,1.164-3.195,2.864v1.648a1.17382,1.17382,0,0,0,.236,1.728,4.61648,4.61648,0,0,0,1.127,2.006v.736c-.224.7-2.898,1.827-5.306,2.734a.52374.52374,0,0,0-.341.489v1.033",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.66382,38.48038h25.312m-20.067,5.528h3.375m5.062,0h6.384m-14.175-26.87h-2.778a3.05168,3.05168,0,0,0-3.141,2.921v26.32a2.90563,2.90563,0,0,0,3.141,2.736h19.085a2.905,2.905,0,0,0,3.141-2.736v-26.32a3.051,3.051,0,0,0-3.141-2.921h-2.778m-4.87-8.058h-3.788a1.27319,1.27319,0,0,0-1.265,1.345l.756,6.934a1.20122,1.20122,0,0,0,1.264.957h2.277a1.19,1.19,0,0,0,1.264-.942l.756-6.973A1.26938,1.26938,0,0,0,34.21382,9.08036Z",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgId);
export default __webpack_public_path__ + "static/media/id.dd3916407abfc1c123686a869d12ac29.svg";
export { ForwardRef as ReactComponent };